module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Reitnau_AG-62891c4f4190c572f4762b6bd353af73.svg";